import { Col, Input, Label } from "reactstrap";
import { IMAGE_WITH_CHECKBOX_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const DynamicImagesWithCheckbox = () => {
  return (
    <>
      {IMAGE_WITH_CHECKBOX_LIST.map(({ src, label, id, defaultChecked, disabled, alt }, index) => (
        <Col xxl="3" sm="6" key={index}>
          <div className="card-wrapper border rounded-3 checkbox-checked">
            <H6 className="sub-title">{label}</H6>
            <div className="img-checkbox">
              <Input className="main-img-cover form-check-input" id={id} type="checkbox" name="radio6" defaultChecked={defaultChecked} disabled={disabled} />
              <Label className="form-check-label mb-0" htmlFor={id}>
                <Image src={dynamicImage(`switch/${src}.jpg`)} alt={alt} />
              </Label>
            </div>
          </div>
        </Col>
      ))}
    </>
  );
};
